<div id="recibo" class="recibo">

  <div class="header">
    <div class="header__start">
      <div class="header__start__logo">
        <!-- TODO: Tornar logo adaptável à empresa -->
        <img class="img-logo" src="../../../assets/images/apnetworks/logo/apnLogoLoginMobile.png">
      </div>
      <div class="header__start__info">
        <p class="header__start__info__text"><b>ALTA PERFORMANCE SERVICOS DE INFORMATICA LTDA</b></p>
        <!-- TODO: CNPJ precisa ser alterado -->
        <p class="header__start__info__text"><b>CNPJ: 06.787.407/0001-97</b></p>
        <p class="header__start__info__text"><b>INSCRIÇÃO ESTADUAL: 77761560</b></p>
        <p class="header__start__info__text">ESTRADA DOS TRES RIOS, 741 - FREGUESIA (JACAREPAGUÁ)</p>
        <p class="header__start__info__text">RIO DE JANEIRO - RJ - Cep: 22745004</p>
        <p class="header__start__info__text header__start__info__space">
          <span><b>Fone: </b>(21) 3624-4925</span>
          <span><b>Site: </b>www.apnetworks.com.br</span>
        </p>
        <p class="header__start__info__text"><b>E-Mail: </b>adm@apnetworks.com.br</p>
      </div>
    </div>
    <div class="header__end">
      <div class="header__end__locacao">
        <p class="header__end__locacao__title"><b>Fatura de Locação</b></p>
        <p class="header__end__locacao__info"><b>R40645</b></p>
      </div>
      <div class="header__end__emissao">
        <p><b>Emissão:</b></p>
        <p>02/09/2021</p>
      </div>
    </div>
  </div>

  <div class="body">

    <p class="title"><b>DESTINATÁRIO DA LOCAÇÃO:</b></p>
    <div class="body__destinatario">
      <span class="body__destinatario__linha">
        <div class="body__destinatario__linha__item">
          <p><b>Nome / Razão Social do Cliente:</b></p>
          <p>SCHNEIDER ADVOGADOS ASSICOADOS</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>CPF / CNPJ do Cliente:</b></p>
          <p>05.111.712/0001-00</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Inscrição Estadual:</b></p>
          <p></p>
        </div>
      </span>
      <span class="body__destinatario__linha">
        <div class="body__destinatario__linha__item">
          <p><b>Enderaço:</b></p>
          <p>TRAVESSA DO OUVIDOR</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Número:</b></p>
          <p>15</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Complemento:</b></p>
          <p>SLJ 201 SALA 501</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Bairro:</b></p>
          <p>CENTRO</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Cep:</b></p>
          <p>20.040-040</p>
        </div>
      </span>
      <span class="body__destinatario__linha u-margin-0">
        <div class="body__destinatario__linha__item">
          <p><b>Município:</b></p>
          <p>RIO DE JANEIRO</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Telefone:</b></p>
          <p>2122214481</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>UF:</b></p>
          <p>RJ</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Inscrição Municipal:</b></p>
          <p></p>
        </div>
      </span>
      <span class="body__destinatario__linha">
        <div class="body__destinatario__linha__item">
          <p><b>E-Mail:</b></p>
          <p>marcelo.teixeira@schneiderassociados.com.br</p>
        </div>
        <div class="body__destinatario__linha__item">
          <p><b>Site:</b></p>
          <p></p>
        </div>
      </span>
      <span class="body__destinatario__linha">
        <div class="body__destinatario__linha__item">
          <p><b>Classificação do Contrato:</b></p>
          <p>OUTSOURCING - 36 MESES / FRANQUIA + EXCEDENTE</p>
        </div>
      </span>
    </div>

    <p class="title"><b>FATURA:</b></p>
    <div class="body__fatura">
      <div class="body__fatura__block body__fatura__block__start">
        <div class="body__fatura__block__info">
          <p><b>Num Fatura</b></p>
          <p>R40645-1</p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>Vencimento</b></p>
          <p>12/09/2021</p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>R$ Fatura</b></p>
          <p>375.75</p>
        </div>
      </div>
      <div class="body__fatura__block body__fatura__block__center">
        <div class="body__fatura__block__info">
          <p><b>Num Fatura</b></p>
          <p></p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>Vencimento</b></p>
          <p></p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>R$ Fatura</b></p>
          <p></p>
        </div>
      </div>
      <div class="body__fatura__block body__fatura__block__end">
        <div class="body__fatura__block__info">
          <p><b>Num Fatura</b></p>
          <p></p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>Vencimento</b></p>
          <p></p>
        </div>
        <div class="body__fatura__block__info">
          <p><b>R$ Fatura</b></p>
          <p></p>
        </div>
      </div>
    </div>

    <div class="body__fatura-info">
      <div class="body__fatura-info__start">
        <div class="body__fatura-info__info body__fatura-info__info__left">
          <p><b>Código</b></p>
          <p>00006</p>
        </div>
        <div class="body__fatura-info__info body__fatura-info__info__left">
          <p><b>Descrição da Locação:</b></p>
          <p>FRANQUIA PRETO E BRANCO</p>
        </div>
      </div>
      <div class="body__fatura-info__end">
        <div class="body__fatura-info__info body__fatura-info__info__right">
          <p><b>UN</b></p>
          <p>UN</p>
        </div>
        <div class="body__fatura-info__info body__fatura-info__info__right">
          <p><b>Quantidade</b></p>
          <p>1</p>
        </div>
        <div class="body__fatura-info__info body__fatura-info__info__right">
          <p><b>Valor Item</b></p>
          <p>375.75015</p>
        </div>
        <div class="body__fatura-info__info body__fatura-info__info__right">
          <p><b>Valor Total Item</b></p>
          <p>37,575,015.00</p>
        </div>
      </div>
    </div>

    <div class="body__fatura-valores">
      <div class="body__fatura-valores__column">
        <div class="body__fatura-valores__info body__fatura-valores__info__sup">
          <p><b>Valor PIS Retido</b></p>
          <p><b>0.00</b></p>
        </div>
        <div class="body__fatura-valores__info">
          <p><b>Valor COFINS Retido</b></p>
          <p><b>0.00</b></p>
        </div>
      </div>
      <div class="body__fatura-valores__column">
        <div class="body__fatura-valores__info body__fatura-valores__info__sup">
          <p><b>Valor CSLL Retido</b></p>
          <p><b>0.00</b></p>
        </div>
        <div class="body__fatura-valores__info">
          <p><b>Valor IR Retido</b></p>
          <p><b>0.00</b></p>
        </div>
      </div>
      <div class="body__fatura-valores__column">
        <div class="body__fatura-valores__info body__fatura-valores__info__sup">
          <p><b>Valor Caução</b></p>
          <p><b>0.00</b></p>
        </div>
        <div class="body__fatura-valores__info">
          <p><b>Valor do Desconto</b></p>
          <p><b>0.00</b></p>
        </div>
      </div>
      <div class="body__fatura-valores__column">
        <div class="body__fatura-valores__info body__fatura-valores__info__sup">
          <p><b>Total da Fatura</b></p>
          <p><b>375.75</b></p>
        </div>
        <div class="body__fatura-valores__info">
          <p><b>Total da Fatura - Retenções - Descontos</b></p>
          <span class="body__fatura-valores__info__total"><b>375.75</b></span>
        </div>
      </div>
    </div>

    <div class="body__fatura-rodape">
      <p><b>Val Aprox Tributos R$103.14 (27.45%) Fonte:IBPT</b></p>
      <div class="body__fatura-rodape__main">
        <p>EQUIPAMENTO(S) INSTALADOS(S) EM: RIO DE JANEIRO-RJ,</p>
        <p>CONTRATO: 2333-31</p>
        <p>REFERENTE: 08/2021</p>
        <p>É DISPENSADO DE EMISSÃO DE NOTA FISCAL DE ACORDO COM LEI COMPLEMENTAR 116/2023 ITEM 3.01</p>
        <p>LOCAÇÃO LEI FEDERAL N. 8846 DE 21/01/1994</p>
      </div>
      <p>PERIODO 01/08/21 A 31/08/21</p>
    </div>

  </div>

  <div class="footer">
    <p class="title">"EMPRESA OPTANTE PELO SIMPLES NACIONAL, NÃO PERMITE APROVEITAMENTO DE CRÉDITO"</p>

    <div class="footer__fatura">
      <div class="footer__fatura__block footer__fatura__block__start">
        <div class="footer__fatura__block__sup">
          <p><b>Fatura de Locação:</b></p>
        </div>
        <div class="footer__fatura__block__inf">
          <span class="footer__fatura__block__inf__fatura"><b>R40645</b></span>
        </div>
      </div>
      <div class="footer__fatura__block footer__fatura__block__end">
        <div class="footer__fatura__block__sup">
          <p><b>Estamos de Acordo com a Emissão desta Fatura:</b></p>
        </div>
        <div class="footer__fatura__block__inf">
          <p><b>RIO DE JANEIRO, ____/____/________</b></p>
          <p><b>Assinatura:________________________________________</b></p>
        </div>
      </div>
    </div>
  </div>

</div>

<app-botoes-files (OnClickApplyPDFButton)="exportarPdf();"></app-botoes-files>